var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"wl-dynamic-freshness"},[_vm._v("\n  Data checked for accuracy: "+_vm._s(_vm.formattedDate)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }